import { useState } from "react";
import { Bell, Check, CheckCheck, X } from "lucide-react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

import { useNotifications } from "@/notifications";

const DISMISS_KEY = "unread-popup-dismissed";

// Popup che compare all'apertura dell'app finché ci sono avvisi non letti:
// «Chiudi per ora» lo nasconde per tutta la sessione (non ricompare a ogni pagina).
export default function UnreadNotificationsPopup() {
  const { notifications, markRead, markAllRead, unreadCount } = useNotifications();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISS_KEY) === "1");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const dismiss = () => { sessionStorage.setItem(DISMISS_KEY, "1"); setDismissed(true); };

  const unread = notifications.filter((notification) => !notification.read && notification.is_own !== false);
  if (dismissed || !unread.length) return null;

  const readOne = async (notification) => {
    try { await markRead(notification); } catch (error) { toast.error(error.message); }
  };
  const readAll = async () => {
    setBusy(true);
    try { await markAllRead(); } catch (error) { toast.error(error.message); } finally { setBusy(false); }
  };
  const openArchive = () => { dismiss(); navigate("/notifiche"); };

  return <div className="modal-backdrop" data-testid="unread-notifications-popup" style={{ zIndex: 55 }}>
    <div className="completion-modal">
      <div className="section-heading">
        <div><p className="eyebrow">AVVISI</p><h2 data-testid="unread-popup-title">{unreadCount === 1 ? "Hai 1 avviso da leggere" : `Hai ${unreadCount} avvisi da leggere`}</h2></div>
        <Bell size={22} />
      </div>
      <p className="birthday-subtitle" data-testid="unread-popup-subtitle">Questo promemoria compare a ogni apertura dell'app finché gli avvisi non vengono segnati come letti.</p>
      <ul className="birthday-list" data-testid="unread-popup-list" style={{ maxHeight: 320, overflowY: "auto" }}>
        {unread.slice(0, 20).map((notification) => <li key={notification.id} data-testid={`unread-popup-item-${notification.id}`} style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
          <div style={{ flex: 1 }}>
            <strong>{notification.title}</strong>
            <span style={{ display: "block" }}>{notification.message}</span>
          </div>
          <button type="button" className="icon-button" data-testid={`unread-popup-read-${notification.id}`} title="Segna come letto" onClick={() => readOne(notification)}><Check size={16} /></button>
        </li>)}
        {unread.length > 20 && <li style={{ opacity: 0.7 }}>… e altri {unread.length - 20} avvisi nell'archivio.</li>}
      </ul>
      <div className="modal-actions" style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <button data-testid="unread-popup-mark-all" className="primary-button" type="button" disabled={busy} onClick={readAll}><CheckCheck size={16} />{busy ? "Salvataggio…" : "Segna tutti come letti"}</button>
        <button data-testid="unread-popup-open-archive" className="secondary-button" type="button" onClick={openArchive}><Bell size={15} />Apri gli avvisi</button>
        <button data-testid="unread-popup-close" className="secondary-button" type="button" onClick={dismiss}><X size={15} />Chiudi per ora</button>
      </div>
    </div>
  </div>;
}
